$(document).ready(function() {
  var metafield = $('.t4s-tab-wrapper').data('id-symbol-fmp') || "";
  var param;  
  if (metafield.trim() !== "") {param = metafield;} 
  else {param = document.URL.split("products/")[1].split("?")[0].toUpperCase();}  
    $.getJSON('https://financialmodelingprep.com/api/v3/financial-growth/'+param+'?limit=1&apikey=3ccf620ce9315de8a4996e601373f716', function(data){
      $.each(data, function(i, elem){
          

/*Это Dividends & Yields*/

         if (elem.dividendsperShareGrowth == null) {var dividendsperShareGrowth_var = 'n/a';} else
         {var dividendsperShareGrowth_var = elem.dividendsperShareGrowth.toLocaleString('en-US', {style: 'percent', minimumFractionDigits:2});}
         $('#stat_dividend_growth_yoy').append(dividendsperShareGrowth_var);


        
      });
    })
});